import React, { useCallback, useContext, useEffect, useState } from 'react';
import {
  Button,
  Col,
  Container,
  Image,
  Row,
} from 'react-bootstrap';
import { useNavigate } from "react-router-dom";

import AuthContext from '../../Context/authContext';
import { getOwnerSpots } from '../../Services/api';
import PlaceholderImg from '../../Assets/Images/download.svg';
import SearchBox from 'src/Components/SearchBox';
import { isSearchableString } from 'src/Utils/queryHelpers';
import Notification, { useNotification } from 'src/Components/Notification';
import "./style.css";


const DashBoardPage = () => {
  const { setIsAdmin, user, setOwnersSpots, ownersSpots } = useContext(AuthContext);
  const [searchStr, setSearchStr] = useState("");
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate();
  const { notifyError, notification } = useNotification()
  const searchTerm = isSearchableString(searchStr) ? searchStr : null;

  const getSpots = useCallback(async () => {
    setIsLoading(true)
    const resp = await getOwnerSpots(user.id, null, searchTerm);
    if (resp.status === 200) {
      setOwnersSpots(resp.data);
    } else {
      notifyError({ message: resp.message });
    }
    setIsLoading(false)
  }, [user, setOwnersSpots, searchTerm, notifyError]);

  useEffect(() => {
    setIsAdmin(true);
    if (user && Object.keys(user).length) {
      getSpots();
    }
  }, [setIsAdmin, getSpots, user]);

  return (
    <Container className="mt-4">
      <Notification id="dashboard-error" {...notification} />
      <div className='row' style={{ paddingBottom: 15, paddingTop: 20 }}>
        <div className="d-inline-flex align-items-center col-6">
          <h4 className="mb-0">Spots</h4>
        </div>
        <div className='col-6'>
          <Button
            className="jamlyfSolidBtn float-end"
            onClick={() => navigate('/spot/new')}
          >
            Add Spot
          </Button>
        </div>
      </div>
      <div className='row mb-3'>
        <div className="col-12 col-lg-8">
          <SearchBox
            id="formSpotSearch"
            placeholder="Search spot"
            defaultValue={searchStr}
            onChange={setSearchStr}
            isLoading={isLoading && isSearchableString(searchStr)}
            onReset={() => setSearchStr("")}
            disabled={!searchStr && !ownersSpots?.length}
          />
        </div>
      </div>
      <Row>
        {ownersSpots.map((spot, i) => (
          <Col key={i} xs={12} lg={4}>
            <div
              className='spot-container'
              onClick={() => navigate(`/spot/${spot.id}/staff`)}
            >
              <figure className="figure">
                <Image
                  src={spot.images.length ? spot.images[0].url : PlaceholderImg}
                  fluid
                  className="figure-img rounded spot-image"
                  onError={(e) => { e.target.src = PlaceholderImg }}
                />
              </figure>
              <p className='spot-name'>{spot.name}</p>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default DashBoardPage;
